import React from 'react';
import { Link } from 'react-router-dom';

function NavigationBar({ theme, toggleTheme }) {
  return (
    <div className="navbar bg-base-100/80 backdrop-blur-md sticky top-0 z-50 px-4 lg:px-8 border-b border-white/5">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </label>
          <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-200 rounded-box w-52">
            <li><Link to="/home">Home</Link></li>
            <li><Link to="/background">Background</Link></li>
            <li><Link to="/aboutus">About Us</Link></li>
            <li>
              <span className="cursor-default">Services</span>
              <ul className="p-2">
                <li><Link to="/realtime">Real-time Webcam</Link></li>
                <li><Link to="/fromimg">From Photos</Link></li>
                <li><Link to="/fromvid">From Video</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <Link to="/" className="text-2xl font-black bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          NSLRAPP
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1 font-medium space-x-2">
          <li><Link to="/home" className="hover:text-primary transition-colors">Home</Link></li>
          <li><Link to="/background" className="hover:text-primary transition-colors">Background</Link></li>
          <li><Link to="/aboutus" className="hover:text-primary transition-colors">About Us</Link></li>
          <li tabIndex={0}>
            <details>
              <summary className="hover:text-primary transition-colors">Services</summary>
              <ul className="p-2 bg-base-200 rounded-t-none w-56">
                <li><Link to="/realtime">Real-time Webcam</Link></li>
                <li><Link to="/fromimg">From Photos</Link></li>
                <li><Link to="/fromvid">From Video</Link></li>
              </ul>
            </details>
          </li>
        </ul>
      </div>
      <div className="navbar-end">
        <label className="swap swap-rotate btn btn-ghost btn-circle">
          <input type="checkbox" onChange={toggleTheme} checked={theme === "winter"} />
          {/* sun icon */}
          <svg className="swap-on fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12.02,0-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71a1,1,0,0,0-1.41-1.41ZM12,18a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V19A1,1,0,0,0,12,18ZM17.66,17a1,1,0,0,0-.7.29,1,1,0,0,0,0,1.41l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,7a5,5,0,1,0,5,5A5,5,0,0,0,12,7Zm0,8a3,3,0,1,1,3-3A3,3,0,0,1,12,15ZM19,11H18a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-1.34-4.66a1,1,0,0,0-1.41,0l-.71.71a1,1,0,1,0,1.41,1.41l.71-.71A1,1,0,0,0,17.66,6.34Z"/></svg>
          {/* moon icon */}
          <svg className="swap-off fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"/></svg>
        </label>
      </div>
    </div>
  );
}

export default NavigationBar;
